import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./CrudeTank1.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";

import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function CrudeTank1({ setPage }) {

  

    useEffect(() => {
    
      trackPageVisit("CrudeTank1");
    
    }, []);
  
     const {  valves, toggleValve, updateTransmitter} = useContext(WellContext);


  const {processData,  setProcessData} = useContext(ProcessContext);
const [hoveredValve, setHoveredValve] = useState(null);
const [showMDS, setShowMDS] = useState(false);

     

  const DEFAULT_VALVES = {
  FCV_1301: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_1302: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_1303: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_1304: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("CrudeTank1_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_1301: { ...DEFAULT_VALVES.FCV_1301, ...parsed.FCV_1301 },
      FCV_1302: { ...DEFAULT_VALVES.FCV_1302, ...parsed.FCV_1302 },
      FCV_1303: { ...DEFAULT_VALVES.FCV_1303, ...parsed.FCV_1303 },
      FCV_1304: { ...DEFAULT_VALVES.FCV_1304, ...parsed.FCV_1304 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("CrudeTank1_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);





  // ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================
const { transmitters, flowOverrides} = usePlantStore();
const FIC_1001 = transmitters.FIC_1001 || 0;
const FIC_1104 = transmitters.FIC_1104 || 0;
const FIC_1201 = transmitters.FIC_1201 || 0;







    const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };




  const xv1301Open = !valves?.XV_1301;
  const xv1302Open = !valves?.XV_1302;
  const xv1303Open = !valves?.XV_1303;
  const xv1304Open = !valves?.XV_1304;
  const xv1305Open = !valves?.XV_1305;
  const xv1306Open = !valves?.XV_1306;
  const xv1307Open = !valves?.XV_1307;
  const xv1308Open = !valves?.XV_1308;
  const xv1309Open = !valves?.XV_1309;
  const xv13010Open = !valves?.XV_13010;
  const xv13011Open = !valves?.XV_13011;
  const xv13012Open = !valves?.XV_13012;
  const xv13015Open = !valves?.XV_13015;
  const xv13017Open = !valves?.XV_13017;
  const xv13020Open = !valves?.XV_13020;
  const xv13016Open = !valves?.XV_13016;
  const xv13014Open = !valves?.XV_13014;
  const xv13018Open = !valves?.XV_13018;
  const xv13013Open = !valves?.XV_13013;
  const xv13019Open = !valves?.XV_13019;




      const  FIC_1301 = FIC_1001;
      const  FIC_1302 = FIC_1104;
      const  FIC_1303 = FIC_1201;
      




    const activeCount =
  (xv1301Open && xv1308Open ? 1 : 0) +
  (xv1305Open && xv1304Open ? 1 : 0) +
  (xv13015Open && xv13020Open ? 1 : 0) +
  (xv13017Open && xv13016Open ? 1 : 0);

const baseFlow = FIC_1301;

const splitFlow = () =>
  activeCount > 0
    ? baseFlow / activeCount
    : 0;

const MarineTerminalCrudeTank1_1301 =
  xv1301Open && xv1308Open
    ? splitFlow()
    : 0;

const MarineTerminalCrudeTank1_1302 =
  xv1305Open && xv1304Open
    ? splitFlow()
    : 0;

const MarineTerminalCrudeTank2_1303 =
  xv13015Open && xv13020Open
    ? splitFlow()
    : 0;

const MarineTerminalCrudeTank2_1304 =
  xv13017Open && xv13016Open
    ? splitFlow()
    : 0;

 

          useEffect(() => {
            localStorage.setItem("MarineTerminalCrudeTank2_1303", MarineTerminalCrudeTank2_1303);
          }, [MarineTerminalCrudeTank2_1303]);

          useEffect(() => {
            localStorage.setItem("MarineTerminalCrudeTank2_1304", MarineTerminalCrudeTank2_1304);
          }, [MarineTerminalCrudeTank2_1304]);





  /* =========================================================
   PIPELINE IMPORT FLOW SPLIT
========================================================= */

const activeImportCount = (xv1302Open && xv1308Open ? 1 : 0) + (xv1306Open && xv1304Open ? 1 : 0) + (xv13014Open && xv13020Open ? 1 : 0) + (xv13018Open && xv13016Open ? 1 : 0);

/* =========================================================
   MAIN PIPELINE FLOW
========================================================= */

const importBaseFlow = FIC_1302;

/* =========================================================
   SPLIT FLOW FUNCTION
========================================================= */

const importSplitFlow = (active) => activeImportCount > 0 ? importBaseFlow / activeImportCount : 0;

/* =========================================================
   IMPORT LINES
========================================================= */

const PipelineImportCrudeTank1_1301 = xv1302Open && xv1308Open ? importSplitFlow() : 0;
const PipelineImportCrudeTank2_1302 = xv1306Open && xv1304Open ? importSplitFlow() : 0;
const PipelineImportCrudeTank2_1303 = xv13014Open && xv13020Open ? importSplitFlow() : 0;
const PipelineImportCrudeTank2_1304 = xv13018Open && xv13016Open ? importSplitFlow() : 0;

useEffect(() => {

  updateTransmitter(
    "PipelineImportCrudeTank1_1301",
    PipelineImportCrudeTank1_1301
  );

  updateTransmitter(
    "PipelineImportCrudeTank2_1302",
    PipelineImportCrudeTank2_1302
  );


}, [  PipelineImportCrudeTank1_1301, PipelineImportCrudeTank2_1302]);


          useEffect(() => {
            localStorage.setItem("PipelineImportCrudeTank2_1303", PipelineImportCrudeTank2_1303);
          }, [PipelineImportCrudeTank2_1303]);

          useEffect(() => {
            localStorage.setItem("PipelineImportCrudeTank2_1304", PipelineImportCrudeTank2_1304);
          }, [PipelineImportCrudeTank2_1304]);





/* =========================================================
   LOADING GANTRY FLOW PATHS
========================================================= */

const activeTruckOffloadingCount = (xv1303Open && xv1308Open ? 1 : 0) + (xv1307Open && xv1304Open ? 1 : 0) + (xv13013Open && xv13020Open ? 1 : 0) + (xv13019Open && xv13016Open ? 1 : 0);

/* =========================================================
   MAIN TRUCK OFFLOADING FLOW
========================================================= */

const TruckOffladingBaseFlow = FIC_1303;

/* =========================================================
   SPLIT FLOW FUNCTION
========================================================= */

const truckOffloadingSplitFlow = (active) => activeTruckOffloadingCount > 0 ? TruckOffladingBaseFlow / activeTruckOffloadingCount : 0;

/* =========================================================
   TRUCK OFFLOADING LINES
========================================================= */

const LoadingGantryCrudeTank1_1301 = xv1303Open && xv1308Open ? truckOffloadingSplitFlow() : 0;
const LoadingGantryCrudeTank1_1302 = xv1307Open && xv1304Open ? truckOffloadingSplitFlow() : 0;
const LoadingGantryCrudeTank2_1303 = xv13013Open && xv13020Open ? truckOffloadingSplitFlow() : 0;
const LoadingGantryCrudeTank2_1304 = xv13019Open && xv13016Open ? truckOffloadingSplitFlow() : 0;

useEffect(() => {

  updateTransmitter(
    "LoadingGantryCrudeTank1_1301",
    LoadingGantryCrudeTank1_1301
  );

  updateTransmitter(
    "LoadingGantryCrudeTank1_1302",
    LoadingGantryCrudeTank1_1302
  );



}, [  LoadingGantryCrudeTank1_1301, LoadingGantryCrudeTank1_1302]);




          useEffect(() => {
            localStorage.setItem("LoadingGantryCrudeTank2_1303", LoadingGantryCrudeTank2_1303);
          }, [LoadingGantryCrudeTank2_1303]);

          useEffect(() => {
            localStorage.setItem("LoadingGantryCrudeTank2_1304", LoadingGantryCrudeTank2_1304);
          }, [LoadingGantryCrudeTank2_1304]);



  /* =========================================================
   P-1301A / P-1301B LOADING TRANSFER PUMPS
========================================================= */


/* =========================================================
   PUMP CONTEXT
========================================================= */
const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});


/* =========================================================
   PUMP STATUS
========================================================= */

const isP1301AOn =
  pumpData?.["P-1301A"]?.running ?? false;

const isP1301BOn =
  pumpData?.["P-1301B"]?.running ?? false;


/* =========================================================
   EFFECTIVE RUN STATUS
========================================================= */

const P1301A_Active =
  isP1301AOn &&
  xv1309Open;

const P1301B_Active =
  isP1301BOn &&
  xv1309Open;


/* =========================================================
   TOTAL PUMP CAPACITY
========================================================= */

const TOTAL_CAPACITY_1301 = 15.564;


/* =========================================================
   RUNNING PUMPS
========================================================= */

const activePumpCount1301 =
[
  P1301A_Active,
  P1301B_Active
].filter(Boolean).length;


/* =========================================================
   CONTROL VALVES
========================================================= */

const FCV1301 =
  Number(
    valveData?.FCV_1301?.opening || 0
  ) / 100;

const FCV1302 =
  Number(
    valveData?.FCV_1302?.opening || 0
  ) / 100;


/* =========================================================
   TOTAL PUMP OUTPUT TARGET
   FCV1301 CONTROLS PUMP CAPACITY
========================================================= */

const pumpOutputTarget1301 =
(
  P1301A_Active ||
  P1301B_Active
)
  ? TOTAL_CAPACITY_1301 * FCV1301
  : 0;


/* =========================================================
   MINIMUM FLOW BYPASS
   FCV1302 CONTROLS SPLIT
========================================================= */

const bypassFlowTarget =
  pumpOutputTarget1301 * FCV1302;


/* =========================================================
   MAIN DISCHARGE FLOW
========================================================= */

const dischargeFlowTarget =
Math.max(
  pumpOutputTarget1301 -
  bypassFlowTarget,
  0
);


/* =========================================================
   FIC_1308
   MAIN DISCHARGE FLOW
========================================================= */

const FIC_1308 = flowOverrides?.FIC_1308 ? 0 : (processData.FIC_1308 ?? 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_1308_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_1308 || 0);

    const systemActive =
      P1301A_Active ||
      P1301B_Active;

    const target =
      systemActive
        ? dischargeFlowTarget
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_1308: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  dischargeFlowTarget,
  P1301A_Active,
  P1301B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_1308_LastUpdate",
    String(Date.now())
  );

}, [FIC_1308]);



useEffect(() => {

  const interval =
    setInterval(() => {

      setProcessData(prev => {

        let current =
          Number(prev.FIC_1308 || 0);

        if (
          !P1301A_Active &&
          !P1301B_Active
        ) {

          return {
            ...prev,
            FIC_1308: 0
          };

        }

        const next =
          current +
          (
            dischargeFlowTarget -
            current
          ) * 0.12;

        return {

          ...prev,

          FIC_1308:
            Number(
              next.toFixed(3)
            )

        };

      });

    }, 100);

  return () =>
    clearInterval(interval);

}, [
  dischargeFlowTarget,
  P1301A_Active,
  P1301B_Active,
  setProcessData
]);


/* =========================================================
   FIC_1309
   MINIMUM FLOW BYPASS
========================================================= */

const FIC_1309 = processData.FIC_1309 ?? 0;

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_1309_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_1309 || 0);

    const systemActive =
      P1301A_Active ||
      P1301B_Active;

    const target =
      systemActive
        ? bypassFlowTarget
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_1309: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  bypassFlowTarget,
  P1301A_Active,
  P1301B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_1309_LastUpdate",
    String(Date.now())
  );

}, [FIC_1309]);


useEffect(() => {

  const interval =
    setInterval(() => {

      setProcessData(prev => {

        let current =
          Number(prev.FIC_1309 || 0);

        if (
          !P1301A_Active &&
          !P1301B_Active
        ) {

          return {
            ...prev,
            FIC_1309: 0
          };

        }

        const next =
          current +
          (
            bypassFlowTarget -
            current
          ) * 0.12;

        return {

          ...prev,

          FIC_1309:
            Number(
              next.toFixed(3)
            )

        };

      });

    }, 100);

  return () =>
    clearInterval(interval);

}, [
  bypassFlowTarget,
  P1301A_Active,
  P1301B_Active,
  setProcessData
]);

/* =========================================================
   INDIVIDUAL PUMP FLOWS
========================================================= */

const P1301A_Flow =
  P1301A_Active
    ? (
        FIC_1308 +
        FIC_1309
      ) / activePumpCount1301
    : 0;

const P1301B_Flow =
  P1301B_Active
    ? (
        FIC_1308 +
        FIC_1309
      ) / activePumpCount1301
    : 0;


/* =========================================================
   TOTAL PUMP OUTPUT
========================================================= */

const TotalPumpFlow1301 =
  FIC_1308 + FIC_1309;


/* =========================================================
   DISCHARGE PRESSURE
========================================================= */

const PT_1303 =
(
  P1301A_Active ||
  P1301B_Active
)
  ? 1.8
  : 0;


/* =========================================================
   DISCHARGE TEMPERATURE
========================================================= */

const TT_1303 =
(
  P1301A_Active ||
  P1301B_Active
)
  ? 36
  : 0;


/* =========================================================
   SYSTEM RUNNING STATUS
========================================================= */

const loadingTransferPumpRunning =
(
  P1301A_Active ||
  P1301B_Active
);







/* =========================================================
   FIC_1308 FLOW SPLIT
========================================================= */

const flowPaths1308 =
[
  xv13012Open,
  xv13011Open
].filter(Boolean).length;


/* =========================================================
   TARGET FLOWS
========================================================= */

const FIC_13010_Target =
(
  xv13012Open &&
  flowPaths1308 > 0
)
  ? FIC_1308 / flowPaths1308
  : 0;


const FIC_13011_Target =
(
  xv13011Open &&
  flowPaths1308 > 0
)
  ? FIC_1308 / flowPaths1308
  : 0;


  /* =========================================================
   FIC_13010
   TO BLENDING TANK
========================================================= */

const FIC_13010 = processData.FIC_13010 ?? 0;

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_13010_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_13010 || 0);

    const systemActive =
      P1301A_Active ||
      P1301B_Active;

    const target =
      systemActive
        ? FIC_13010_Target
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_13010: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  FIC_13010_Target,
  P1301A_Active,
  P1301B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_13010_LastUpdate",
    String(Date.now())
  );

}, [FIC_13010]);





useEffect(() => {

  const interval =
    setInterval(() => {

      setProcessData(prev => {

        const current =
          Number(prev.FIC_13010 || 0);

        const next =
          current +
          (
            FIC_13010_Target -
            current
          ) * 0.12;

        return {

          ...prev,

          FIC_13010:
            Number(
              next.toFixed(3)
            )

        };

      });

    }, 100);

  return () =>
    clearInterval(interval);

}, [
  FIC_13010_Target,
  setProcessData
]);


/* =========================================================
   FIC_13011
   TO DAY TANK
========================================================= */

const FIC_13011 = processData.FIC_13011 ?? 0;

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_13011_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_13011 || 0);

    const systemActive =
      P1301A_Active ||
      P1301B_Active;

    const target =
      systemActive
        ? FIC_13011_Target
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_13011: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  FIC_13011_Target,
  P1301A_Active,
  P1301B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_13011_LastUpdate",
    String(Date.now())
  );

}, [FIC_13011]);




useEffect(() => {

  const interval =
    setInterval(() => {

      setProcessData(prev => {

        const current =
          Number(prev.FIC_13011 || 0);

        const next =
          current +
          (
            FIC_13011_Target -
            current
          ) * 0.12;

        return {

          ...prev,

          FIC_13011:
            Number(
              next.toFixed(3)
            )

        };

      });

    }, 100);

  return () =>
    clearInterval(interval);

}, [
  FIC_13011_Target,
  setProcessData
]);





/* =========================================================
   P-1302A / P-1302B TRANSFER PUMPS
========================================================= */


/* =========================================================
   PUMP STATUS
========================================================= */

const isP1302AOn =
  pumpData?.["P-1302A"]?.running ?? false;

const isP1302BOn =
  pumpData?.["P-1302B"]?.running ?? false;


/* =========================================================
   SUCTION VALVE
========================================================= */

const P1302A_Active =
  isP1302AOn &&
  xv13010Open;

const P1302B_Active =
  isP1302BOn &&
  xv13010Open;


/* =========================================================
   TOTAL CAPACITY
========================================================= */

const TOTAL_CAPACITY_1302 = 13.547;


/* =========================================================
   RUNNING PUMPS
========================================================= */

const activePumpCount1302 =
[
  P1302A_Active,
  P1302B_Active
].filter(Boolean).length;


/* =========================================================
   CONTROL VALVES
========================================================= */

const FCV1303 =
  Number(
    valveData?.FCV_1303?.opening || 0
  ) / 100;

const FCV1304 =
  Number(
    valveData?.FCV_1304?.opening || 0
  ) / 100;


/* =========================================================
   MINIMUM FLOW BYPASS
   FCV-1303 → V-1301
========================================================= */

/* =========================================================
   TOTAL PUMP OUTPUT
   FCV1304 CONTROLS PUMP LOADING
========================================================= */

const pumpOutputTarget1302 =
(
  P1302A_Active ||
  P1302B_Active
)
  ? TOTAL_CAPACITY_1302 * FCV1304
  : 0;


/* =========================================================
   MINIMUM FLOW BYPASS
   FCV1303 CONTROLS SPLIT
========================================================= */

const bypassFlowTarget1302 =
  pumpOutputTarget1302 * FCV1303;


/* =========================================================
   MAIN DISCHARGE TO BLENDING TANK
========================================================= */

const dischargeFlowTarget1302 =
Math.max(
  pumpOutputTarget1302 -
  bypassFlowTarget1302,
  0
);


/* =========================================================
   FIC_13012
   MAIN DISCHARGE FLOW
========================================================= */

const FIC_13012 = flowOverrides?.FIC_13012 ? 0 : (processData.FIC_13012 ?? 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_13012_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_13012 || 0);

    const systemActive =
      P1302A_Active ||
      P1302B_Active;

    const target =
      systemActive
        ? dischargeFlowTarget1302
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_13012: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  dischargeFlowTarget1302,
  P1302A_Active,
  P1302B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_13012_LastUpdate",
    String(Date.now())
  );

}, [FIC_13012]);



useEffect(() => {

  const interval =
    setInterval(() => {

      setProcessData(prev => {

        const current =
          Number(prev.FIC_13012 || 0);

        if (
          !P1302A_Active &&
          !P1302B_Active
        ) {

          return {
            ...prev,
            FIC_13012: 0
          };

        }

        const next =
          current +
          (
            dischargeFlowTarget1302 -
            current
          ) * 0.12;

        return {

          ...prev,

          FIC_13012:
            Number(
              next.toFixed(3)
            )

        };

      });

    }, 100);

  return () =>
    clearInterval(interval);

}, [
  dischargeFlowTarget1302,
  P1302A_Active,
  P1302B_Active,
  setProcessData
]);


/* =========================================================
   FIC_13013
   MINIMUM FLOW BYPASS
========================================================= */

const FIC_13013 = processData.FIC_13013 ?? 0;

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_13013_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_13013 || 0);

    const systemActive =
      P1302A_Active ||
      P1302B_Active;

    const target =
      systemActive
        ? bypassFlowTarget1302
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_13013: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  bypassFlowTarget1302,
  P1302A_Active,
  P1302B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_13013_LastUpdate",
    String(Date.now())
  );

}, [FIC_13013]);


useEffect(() => {

  const interval =
    setInterval(() => {

      setProcessData(prev => {

        const current =
          Number(prev.FIC_13013 || 0);

        if (
          !P1302A_Active &&
          !P1302B_Active
        ) {

          return {
            ...prev,
            FIC_13013: 0
          };

        }

        const next =
          current +
          (
            bypassFlowTarget1302 -
            current
          ) * 0.12;

        return {

          ...prev,

          FIC_13013:
            Number(
              next.toFixed(3)
            )

        };

      });

    }, 100);

  return () =>
    clearInterval(interval);

}, [
  bypassFlowTarget1302,
  P1302A_Active,
  P1302B_Active,
  setProcessData
]);


/* =========================================================
   INDIVIDUAL PUMP FLOWS
========================================================= */

const P1302A_Flow =
  P1302A_Active
    ? (
        FIC_13012 +
        FIC_13013
      ) / activePumpCount1302
    : 0;

const P1302B_Flow =
  P1302B_Active
    ? (
        FIC_13012 +
        FIC_13013
      ) / activePumpCount1302
    : 0;


/* =========================================================
   TOTAL PUMP OUTPUT
========================================================= */

const TotalPumpFlow1302 =
  FIC_13012 +
  FIC_13013;


/* =========================================================
   DISCHARGE PRESSURE
========================================================= */

const PT_1304 =
(
  P1302A_Active ||
  P1302B_Active
)
  ? 1.8
  : 0.03;


/* =========================================================
   DISCHARGE TEMPERATURE
========================================================= */

const TT_1304 =
(
  P1302A_Active ||
  P1302B_Active
)
  ? 37
  : 27;


/* =========================================================
   SYSTEM STATUS
========================================================= */

const transferPump1302Running =
(
  P1302A_Active ||
  P1302B_Active
);





/* =========================================================
   UPDATE TRANSMITTERS
========================================================= */

useEffect(() => {

  updateTransmitter("FIC_1308", FIC_1308);

  updateTransmitter("FIC_1309", FIC_1309);

  updateTransmitter("PT_1303", PT_1303);

  updateTransmitter("TT_1303", TT_1303);

  updateTransmitter("FIC_13010", FIC_13010);

  updateTransmitter("FIC_13011", FIC_13011);

  updateTransmitter("TT_1304", TT_1304);

  updateTransmitter("PT_1304", PT_1304);

  updateTransmitter("FIC_13013", FIC_13013);

  updateTransmitter("FIC_13012", FIC_13012);

}, [
  FIC_1308, FIC_1309, PT_1303, TT_1303, FIC_13010, FIC_13011, TT_1304, PT_1304, FIC_13013, FIC_13012,
]);


 





    
    const FIC_1304 = xv1308Open ? MarineTerminalCrudeTank1_1301 + PipelineImportCrudeTank1_1301 + LoadingGantryCrudeTank1_1301 + FIC_13013: 0;
    const FIC_1305 = xv1304Open ? MarineTerminalCrudeTank1_1302 + PipelineImportCrudeTank2_1302 + LoadingGantryCrudeTank1_1302 + FIC_1309: 0;

    useEffect(() => {

  setProcessData(prev => ({
    ...prev,
    FIC_1305
  }));

}, [FIC_1305]);
    
    const TT_1301 = xv1308Open ? 37.983 : 35.433;
    const TT_1302 = xv1304Open ? 37.983 : 35.433;




          
useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_13010 === FIC_13010 && 
    current.FIC_13012 === FIC_13012 && 
    current.FIC_13011 === FIC_13011 &&
    current.FIC_1308 === FIC_1308 &&
    current.MarineTerminalCrudeTank2_1303 === MarineTerminalCrudeTank2_1303 && 
    current.MarineTerminalCrudeTank2_1304 === MarineTerminalCrudeTank2_1304  &&
    current.PipelineImportCrudeTank2_1303 === PipelineImportCrudeTank2_1303  &&
    current.PipelineImportCrudeTank2_1304 === PipelineImportCrudeTank2_1304  &&
    current.LoadingGantryCrudeTank2_1303 === LoadingGantryCrudeTank2_1303  &&
    current.LoadingGantryCrudeTank2_1304 === LoadingGantryCrudeTank2_1304
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_13010, FIC_13012, FIC_1308, FIC_13011, MarineTerminalCrudeTank2_1303, MarineTerminalCrudeTank2_1304, PipelineImportCrudeTank2_1303, PipelineImportCrudeTank2_1304, LoadingGantryCrudeTank2_1303,  LoadingGantryCrudeTank2_1304,
    }
  });

}, [FIC_13010, FIC_13012, FIC_1308, FIC_13011, MarineTerminalCrudeTank2_1303, MarineTerminalCrudeTank2_1304, PipelineImportCrudeTank2_1303, PipelineImportCrudeTank2_1304, LoadingGantryCrudeTank2_1303, LoadingGantryCrudeTank2_1304]);




  return (
    <div className="CrudeTank1-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "225px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 279px",
          zIndex: 10,
        }}
      >
        CRUDE STORAGE TANKS 1
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-1301 */}
      <Valve
        className="XV-1301"
        tag="XV_1301"
        x={219}
        y={349}
        isClosed={valves.XV_1301}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1302 */}
      <Valve
        className="XV-1302"
        tag="XV_1302"
        x={247}
        y={398}
        isClosed={valves.XV_1302}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1303 */}
      <Valve
        className="XV-1303"
        tag="XV_1303"
        x={193}
        y={398}
        isClosed={valves.XV_1303}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1304 */}
      <Valve
        className="XV-1304"
        tag="XV_1304"
        x={656}
        y={239}
        isClosed={valves.XV_1304}
        toggle={toggleValve}
      />

      {/* XV-1305 */}
      <Valve
        className="XV-1305"
        tag="XV_1305"
        x={639}
        y={351}
        isClosed={valves.XV_1305}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1306 */}
      <Valve
        className="XV-1306"
        tag="XV_1306"
        x={659}
        y={399}
        isClosed={valves.XV_1306}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-1307 */}
      <Valve
        className="XV-1307"
        tag="XV_1307"
        x={614}
        y={399}
        isClosed={valves.XV_1307}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-1308 */}
      <Valve
        className="XV-1308"
        tag="XV_1308"
        x={236}
        y={238}
        isClosed={valves.XV_1308}
        toggle={toggleValve}
      />

      
      {/* XV-1309 */}
      <Valve
        className="XV-1309"
        tag="XV_1309"
        x={360}
        y={348}
        isClosed={valves.XV_1309}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13010 */}
      <Valve
        className="XV-13010"
        tag="XV_13010"
        x={941}
        y={275}
        isClosed={valves.XV_13010}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13011 */}
      <Valve
        className="XV-13011"
        tag="XV_13011"
        x={1064}
        y={652}
        isClosed={valves.XV_13011}
        toggle={toggleValve}
      />

      {/* XV-13012 */}
      <Valve
        className="XV-13012"
        tag="XV_13012"
        x={1064}
        y={579}
        isClosed={valves.XV_13012}
        toggle={toggleValve}
      />

      



      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1301 */}
          <div
            style={{
              position: "absolute",
              left: 860,
              top: 569
            }}
            onMouseEnter={() => setHoveredValve("FCV_1301")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1301")}
          >

            {hoveredValve === "FCV_1301" && (
              <div style={tagStyle}>
                FCV_1301
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1301">

              <defs>
                <linearGradient id="metal_1301">
                  <stop offset="0%" stopColor="#bdc3c7" />
                  <stop offset="50%" stopColor="#ecf0f1" />
                  <stop offset="100%" stopColor="#7f8c8d" />
                </linearGradient>
              </defs>

              <path
                d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
                fill="#eb2a11"
                stroke="#3498db"
                strokeWidth="2"
              />

              <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

              <polygon
                points="20,200 100,150 20,110"
                fill="url(#metal_1301)"
                stroke="#7f8c8d"
                strokeWidth="2"
              />

              <polygon
                points="180,200 100,150 180,110"
                fill="url(#metal_1301)"
                stroke="#7f8c8d"
                strokeWidth="2"
              />

            </svg>
          </div>


         {/* FCV-1302 */}
          <div
            style={{ position: "absolute", left: 666, top: 511, transform: "rotate(90deg)", transformOrigin: "center" }}
            onMouseEnter={() => setHoveredValve("FCV_1302")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1302")}
          >

            {hoveredValve === "FCV_1302" && (
              <div style={tagStyle}>
                FCV_1302
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1302">

          
          <defs>
            <linearGradient id="metal_1302">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1302)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1302)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
          </div>





      {/* FCV-1303 */}
         <div
            style={{ position: "absolute", left: 1060, top: 296}}
            onMouseEnter={() => setHoveredValve("FCV_1303")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1303")}
          >
          {hoveredValve === "FCV_1303" && (
            <div style={tagStyle}>
              FCV_1303
            </div>
          )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1303">
                    
          <defs>
            <linearGradient id="metal_1303">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1303)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1303)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>



      {/* FCV-1304 */}
         <div
            style={{ position: "absolute", left: 1130, top: 409}}
            onMouseEnter={() => setHoveredValve("FCV_1304")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1304")}
          >
          {hoveredValve === "FCV_1304" && (
            <div style={tagStyle}>
              FCV_1304
            </div>
          )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1304">
                    
          <defs>
            <linearGradient id="metal_1304">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1304)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1304)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



          {/* ================= MDS FACEPLATE ================= */}

          {showMDS && (
            <MDSFaceplate
                close={() => setShowMDS(false)}
                tankID={1}
                storageKey="TANK1_SELECTED_CRUDE"
                mode="tank"
            />
          )}

           

      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_1301?.opening || 0)}
        x={881}
        y={615}
      />

      <ValveOutput
        value={Number(valveData?.FCV_1302?.opening || 0)}
        x={658}
        y={530}
      />

      <ValveOutput
        value={Number(valveData?.FCV_1303?.opening || 0)}
        x={1082}
        y={336}
      />

      <ValveOutput
        value={Number(valveData?.FCV_1304?.opening || 0)}
        x={1152}
        y={454}
      />


        <button
          onClick={() => setShowMDS(true)}
          style={{
            position: "absolute",
            top: "150px",
            left: "150px",
            padding: "5px 2px",
            background: "#ff9800",
            color: "#000",
            border: "none",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 500
          }}
        >
          Crude MDS
        </button>





        <Transmitter
          tag="FIC_1301"
          value={[FIC_1301]}
          x={105}
          y={354}
          unit="BPM"
          max={15}
          HH={13}
          H={9}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM DISCHARGE OF CRUDE CUSTODY TRANSFER PUMPS OF MARINE TERMINAL INTO CRUDE TANK 2"
         />

        <Transmitter
          tag="FIC_1302"
          value={[FIC_1302]}
          x={105}
          y={409}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM DISCHARGE OF CRUDE CUSTODY TRANSFER PUMPS OF PIPELINE IMPORT INTO CRUDE TANK 2"
         />

        <Transmitter
          tag="FIC_1303"
          value={[FIC_1303]}
          x={105}
          y={455}
          unit="BPM"
          max={1}
          HH={0.95}
          H={0.8}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE FROM DISCHARGE OF CRUDE CUSTODY TRANSFER PUMPS OF PIPELINE IMPORT INTO CRUDE TANK 2"
         />

        <Transmitter
          tag="FIC_1304"
          value={[FIC_1304]}
          x={132}
          y={221}
          unit="BPM"
          max={300}
          HH={248}
          H={245}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF CRUDE FROM MARINE TERMINAL TO SUCTION V-1301"
         />

        <Transmitter
          tag="FIC_1305"
          value={[FIC_1305]}
          x={622}
          y={189}
          unit="BPM"
          max={300}
          HH={248}
          H={245}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF CRUDE FROM MARINE TERMINAL TO SUCTION V-1302"
         />
        <Transmitter
          tag="FIC_1308"
          value={[FIC_1308]}
          x={622}
          y={609}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TRANSFER PUMPS (P-1301A/B) FROM V-1301 TO BLENDING OR DAY TANK"
         />

        <Transmitter
          tag="TT_1303"
          value={[TT_1303]}
          x={712}
          y={609}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE TRANSFER PUMPS (P-1301A/B) FROM V-1301 TO BLENDING OR DAY TANK"
         />

        <Transmitter
          tag="PT_1303"
          value={[PT_1303]}
          x={522}
          y={523}
          unit="MPa"
          max={3}
          HH={2.5}
          H={1.8}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF CRUDE TRANSFER PUMPS (P-1301A/B) FROM V-1301 TO BLENDING OR DAY TANK"
         />

         <Transmitter
          tag="FIC_13010"
          value={[FIC_13010]}
          x={1142}
          y={565}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TRANSFER PUMPS (P-1301A/B) FROM V-1301 TO BLENDING TANK"
         />

         <Transmitter
          tag="FIC_13011"
          value={[FIC_13011]}
          x={1142}
          y={638}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TRANSFER PUMPS (P-1301A/B) FROM V-1301 TO DAY TANK"
         />


         <Transmitter
          tag="FIC_13012"
          value={[FIC_13012]}
          x={1189}
          y={466}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TRANSFER PUMPS (P-1302A/B) FROM V-1301 TO BLENDING TANK"
         />

         <Transmitter
          tag="FIC_13013"
          value={[FIC_13013]}
          x={1142}
          y={288}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TRANSFER PUMPS (P-1302A/B) MINIMUM FLOW BYEPASS LINE FROM V-1302 TO V-1301 TANK"
         />

         <Transmitter
          tag="PT_1304"
          value={[PT_1304]}
          x={1052}
          y={428}
          unit="MPa"
          max={3}
          HH={2.5}
          H={1.8}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF CRUDE TRANSFER PUMPS (P-1302A/B) MINIMUM FLOW BYEPASS LINE FROM V-1302 TO BLENDING TANK"
         />

         <Transmitter
          tag="TT_1304"
          value={[TT_1304]}
          x={1225}
          y={368}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE TRANSFER PUMPS (P-1302A/B) MINIMUM FLOW BYEPASS LINE FROM V-1302 TO BLENDING TANK"
         />

        <Transmitter
          tag="TT_1301"
          value={[TT_1301]}
          x={282}
          y={58}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE ON TANK V-1301"
         />

         <Transmitter
          tag="TT_1302"
          value={[TT_1302]}
          x={692}
          y={58}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE ON TANK V-1302"
         />


       


    <LevelTransmitterIndicator
      tag="LT_1301"
      totalLevel={70000}
      inflows={[FIC_1304]}
      outflows={[FIC_1308]}
      inflowTags={["FIC_1304"]}
      outflowTags={["FIC_1308"]}
      responseFactor={0.05}
      columnX={449}
      columnY={130}
      columnWidth={30}
      columnHeight={162}
      textX={486}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.9}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1301"
      totalLevel={70000}
      inflows={[FIC_1304]}
      outflows={[FIC_1308]}
      inflowTags={["FIC_1304"]}
      outflowTags={["FIC_1308"]}
      responseFactor={0.05}
      columnX={290}
      columnY={130}
      columnWidth={189}
      columnHeight={162}
      textX={486}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1302"
      totalLevel={70000}
      inflows={[processData.FIC_1305 || 0]}
      outflows={[processData.FIC_13012 || 0]}
      inflowTags={["FIC_1305"]}
      outflowTags={["FIC_13012"]}
      responseFactor={0.05}
      columnX={865}
      columnY={130}
      columnWidth={30}
      columnHeight={159}
      textX={910}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.9}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1302"
      totalLevel={70000}
      inflows={[processData.FIC_1305 || 0]}
      outflows={[processData.FIC_13012 || 0]}
      inflowTags={["FIC_1305"]}
      outflowTags={["FIC_13012"]}
      responseFactor={0.05}
      columnX={708}
      columnY={130}
      columnWidth={189}
      columnHeight={159}
      textX={910}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="crude"
    />


    
            <Pump
              tag="P-1301A"
              x={438}
              y={549}
              rpm={1800}
              bladeCount={pumpData?.["P-1301A"]?.bladeCount || 3}
              size={pumpData?.["P-1301A"]?.size || 38}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-1301B"
              x={438}
              y={628}
              rpm={1800}
              bladeCount={pumpData?.["P-1301B"]?.bladeCount || 3}
              size={pumpData?.["P-1301B"]?.size || 38}
              onClick={openPumpPanel}
            />

    
            <Pump
              tag="P-1302A"
              x={1005}
              y={393}
              rpm={1800}
              bladeCount={pumpData?.["P-1302A"]?.bladeCount || 3}
              size={pumpData?.["P-1302A"]?.size || 38}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-1302B"
              x={1005}
              y={474}
              rpm={1800}
              bladeCount={pumpData?.["P-1302B"]?.bladeCount || 3}
              size={pumpData?.["P-1302B"]?.size || 38}
              onClick={openPumpPanel}
            />






    </div>
  );
}

export default CrudeTank1;